import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from './styles';

const SignUp: React.FC = () => {
  return (
    <Container>
      <h1>SignUp</h1>
      <Link to="/home">Voltar para Home</Link>
    </Container>
  );
};

export default SignUp;
